var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.linkageId ? _c('category-mirror-btn', { attrs: { "tips-content": _vm.tipsContent }, on: { "navigateClick": _vm.navigateToRefCategory } }) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };